import { render, staticRenderFns } from "./VehicleSnippet.vue?vue&type=template&id=9b0ac794&scoped=true"
import script from "./VehicleSnippet.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleSnippet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VehicleSnippet.vue?vue&type=style&index=0&id=9b0ac794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0ac794",
  null
  
)

export default component.exports